import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { StyledForm } from "../Auth.styled";
import AuthLayout from "../../layout/AuthLayout";
import { Button } from "../../globalStyle/GlobalStyle";
import Logo from "../../assets/fortcore-icon.png";
import SuccessIcon from "../../assets/img/success-icon.svg";
import { styled } from "styled-components";

const PasswordReset = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [password1, setPassword1] = useState("");
	const [loading, setLoading] = useState(false);
	const [passwordShown, setPasswordShown] = useState(false);
	const [passwordShown1, setPasswordShown1] = useState(false);
	const [status, setStatus] = useState(null);

	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (!location.state?.email) {
			navigate("/forgot-password");
		} else {
			setEmail(location.state.email);
		}
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();

		// Check if password and confirm password match
		if (password !== password1) {
			toast.error("Password and confirm password do not match");
			setLoading(false);
			return;
		} else setLoading(true);

		try {
			const response = await fetch("https://test.fortcoretech.com/api/functions/changePassword", {
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify({ email, password }),
			});

			const res = await response.json();
			if (!res.error) {
				toast.success("Password reset successful");
				setStatus("success");
			} else {
				console.log(res);
				toast.error(res.error);
			}
			setLoading(false);
		} catch (error) {
			console.log(error);
			toast.error("Something went wrong. Please try again.");
			setLoading(false);
		}
	};

	return (
		<Wrapper>
			<AuthLayout>
				{!status ? (
					<>
						<img src={Logo} alt='' />
						<p className='subtext'>Admin Login</p>

						<StyledForm onSubmit={handleSubmit}>
							<label>Email</label>
							<input
								type='email'
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder='Enter email'
								required
								readOnly
							/>

							<label>New password</label>
							<div className='input_group'>
								<input
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									disabled={loading}
									placeholder='Enter password'
									type={passwordShown ? "text" : "password"}
									required
								/>
								<button className='input_icon' onClick={() => setPasswordShown(!passwordShown)} type='button'>
									{passwordShown ? <FaRegEye /> : <FaRegEyeSlash />}
								</button>
							</div>

							<label>Confirm password</label>
							<div className='input_group'>
								<input
									value={password1}
									onChange={(e) => setPassword1(e.target.value)}
									disabled={loading}
									placeholder='Enter password'
									type={passwordShown1 ? "text" : "password"}
									required
								/>
								<button
									className='input_icon'
									onClick={() => setPasswordShown1(!passwordShown1)}
									type='button'>
									{passwordShown1 ? <FaRegEye /> : <FaRegEyeSlash />}
								</button>
							</div>

							<div className='mt-6'>
								<Button type='submit'>{!loading ? "Reset" : <div className='loader'></div>}</Button>
							</div>
						</StyledForm>
					</>
				) : (
					<SuccessContent />
				)}
			</AuthLayout>
		</Wrapper>
	);
};

const SuccessContent = () => {
	return (
		<>
			<img src={Logo} alt='' />
			<p className='subtext'>Success!</p>

			<div className='success_content'>
				<img className='success_icon mt-5' src={SuccessIcon} alt='' />
				<p className='font-bold'>Your password has been successfully reset.</p>

				<Link to='/' className='w-full mt-10 mb-6'>
					<Button type='button'>Login</Button>
				</Link>
			</div>
		</>
	);
};

export const Wrapper = styled.div`
	.success_content {
		display: flex;
		flex-direction: column;
		/* justify-content: center; */
		align-items: center;

		.success_icon {
			width: 110px;
			margin-bottom: 45px;
		}

		._button a {
			color: #fff;
		}
	}
`;

export default PasswordReset;
